import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedBlogDescriptionFromUrl,
  BackendMutationExtractBlogDescriptionFromUrlArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractBlogDescriptionFromUrl($projectId: ID!, $url: String!) {
    extractBlogDescriptionFromUrl(projectId: $projectId, url: $url) {
      id
    }
  }
`;

type Variables = Pick<BackendMutationExtractBlogDescriptionFromUrlArgs, 'projectId' | 'url'>;
type Result = Pick<BackendExtractedBlogDescriptionFromUrl, 'id'>;

export const extractBlogDescriptionFromURL = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
